import { PasswordForm } from "@/components/features/profiles/password-form"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { MainContainer } from "@/components/ui/container"

export default function StaffProfilesEditPassword() {
  return (
    <StaffLayout>
      <MainContainer size="xs">
        <PasswordForm />
      </MainContainer>
    </StaffLayout>
  )
}
